import React from 'react';
import { Select, MenuItem } from '@mui/material';

const FontListComponent = ({ activeFont, onChange }) => {
  const fonts = [
    { name: 'Arial', value: 'Arial' },
    { name: 'Courier New', value: 'Courier New' },
    { name: 'Times New Roman', value: 'Times New Roman' },
    { name: 'Verdana', value: 'Verdana' },
    { name: 'Roboto', value: 'Roboto' },
    { name: 'Open Sans', value: 'Open Sans' },
    { name: 'Lato', value: 'Lato' },
    { name: 'Montserrat', value: 'Montserrat' },
  ];

  return (
    <Select
      value={activeFont}
      onChange={(e) => onChange(e.target.value)}
      displayEmpty
      size="small"
      sx={{
        width: 125,
        fontSize: '0.75rem',
        border: 'none',
        boxShadow: 'none',
        '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
        '&:hover .MuiOutlinedInput-notchedOutline': { border: 'none' },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': { border: 'none' },
      }}
      renderValue={(selected) => {
        const font = fonts.find((f) => f.value === selected);
        return (
          <span style={{ fontFamily: font ? font.value : 'inherit' }}>
            {font ? font.name : 'Select Font'}
          </span>
        );
      }}
    >
      {fonts.map((font) => (
        <MenuItem
          key={font.value}
          value={font.value}
          sx={{ fontFamily: font.value }}
        >
          {font.name}
        </MenuItem>
      ))}
    </Select>
  );
};

export default FontListComponent;
